// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== 공용 ===== */
.container-wrap {
    width: 100%;
    position: relative;
    min-height: 100%;
}

.main-wrap {
    position: relative;
    /* min-height: 100vh; */
    width: 100%;
}

.main-background-image {
    /* position: fixed; */
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
    pointer-events: none;
}

.main-viewport {
    width: 100%;
    max-width: 600px;
    min-height: 100dvh;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow-x: hidden;
    overflow-y: auto;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    z-index: 1;
    box-sizing: border-box;
}

.main-content {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* 비율대로 조정되도록 em 단위 사용 (기본 16px 기준으로 40px = 2.5em) */
    /* margin-top: 1.5em; */
    /* 최소 높이 설정하여 내용이 없어도 화면이 보이도록 */
    min-height: calc(100vh - 240px);
}

/* QR 페이지: 카드 비율 고정(312:512), PC에서 화면 밖으로 나가지 않도록 제한 */
.qr-page-content {
    transform: translateY(-15px);
    width: 100%;
    max-width: 100%;
    min-height: 0;
    overflow: hidden;
    box-sizing: border-box;
}
.qr-page-content .main-slide {
    width: 100%;
    max-width: 85%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
}
.qr-page-content .main-card {
    /* PC에서도 화면 안: 100%·80vw·높이기준 중 최소값, 뷰포트 절대 초과 안 함 */
    width: min(100%, 80vw, calc((100vh - 240px) * 312 / 512));
    max-width: min(100%, 80vw, calc((100vh - 240px) * 312 / 512), 100vw);
    aspect-ratio: 312 / 512;
    height: auto;
    max-height: min(calc(100vh - 240px), 100dvh);
    flex-shrink: 0;
    box-sizing: border-box;
}
.qr-page-content .main-card-inner {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
}

/* ===== Swiper ===== */
.main-swiper-area {
    width: 100%;
    box-sizing: border-box;
    overflow: visible;
}

.main-slide {
    /* Swiper 슬라이드 컨테이너 - 실제 카드 크기는 .main-card에서 제어 */
    display: flex !important;
    justify-content: center;
    align-items: center;
    width: auto;
    /* 카드 크기는 .main-card에서 직접 제어하므로 여기서는 제한하지 않음 */
}

.swiper,
.main-swiper {
    overflow: visible !important;
}

.main-swiper .swiper-pagination {
    position: static;
    margin: 20px auto 0;
    display: flex;
    justify-content: center;
    transform: translateX(0) !important;
}

.main-swiper .swiper-pagination-bullet {
    width: 11px;
    height: 11px;
    background: #c8cdd6;
    opacity: 1;
    margin: 0 4px !important;
}

.main-swiper .swiper-pagination-bullet-active {
    background: #101217;
}

/* ===== 카드 공통 ===== */
.main-card {
    position: relative;
    margin: 0;
    border-radius: 1.75em;
    border-top-right-radius: 4.375em;
    aspect-ratio: 312 / 512;
    /* PC에서 화면 밖으로 나가지 않도록: 100%, 80vw, 높이기준, 100vw 상한 */
    width: min(100%, 80vw, calc((100vh - 240px) * 312 / 512));
    max-width: min(100%, 80vw, calc((100vh - 240px) * 312 / 512), 100vw);
    max-height: min(calc(100vh - 240px), 100dvh);
    min-width: 200px;
    min-height: calc(200px * 512 / 312);
    height: auto;
    flex-shrink: 0;
    box-sizing: border-box;
    /* 뷰포트(vmin) 비율: 화면이 커질수록 폰트·컨텐츠가 같은 퍼센트로 커지게 */
    font-size: clamp(12px, 4.8vmin, 28px);
    color: #fff;
    perspective: 1200px;
    overflow: visible;
    will-change: transform;
}

.main-card-inner {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    transform-style: preserve-3d;
    -webkit-transform-style: preserve-3d;
    transition: transform 800ms cubic-bezier(.2, .8, .2, 1);
}

/* + 카드 스타일 */
.main-add-card {
    display: flex;
    align-items: center;
    justify-content: center;
}

.main-add-card .main-card-inner {
    position: relative;
    transform: none !important;
}

/* 관리자 승인 대기 카드 스타일 */
.main-card-pending {
    position: relative;
}

.main-card-pending-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}

.main-card-pending-message {
    background: rgba(255, 255, 255, 0.95);
    color: #666;
    padding: 1em 1.5em;
    border-radius: 0.75em;
    font-size: 1em;
    font-weight: 600;
    text-align: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.main-card-pending .main-card-face {
    filter: grayscale(100%);
    opacity: 0.6;
}

/* 승인된 자격증은 정상 스타일 */
.main-card:not(.main-card-pending) .main-card-face {
    filter: none;
    opacity: 1;
}

.main-card.is-flipped .main-card-inner {
    transform: rotateY(180deg);
}

.main-card-face {
    position: absolute;
    inset: 0;
    border-radius: inherit;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    overflow: hidden;
    transform: translateZ(0.01px);
}

/* 상단 배지 */
.main-type-badge {
    position: absolute;
    top: -2.1875em; /* 35px를 em으로 변환 */
    left: 0.3125em; /* 5px를 em으로 변환 */
    /* top: 15px; */
    /* left: 50%; */
    /* transform: translateX(-50%); */
    z-index: 3;
    display: inline-flex;
    align-items: center;
    gap: 0.125em; /* 2px를 em으로 변환 */
    font-weight: 800;
    font-size: 1.125em; /* 18px를 em으로 변환 */
    color: #000;
}

.main-type-badge img {
    width: 1.625em; /* 26px를 em으로 변환 */
    height: 1.625em; /* 26px를 em으로 변환 */
    display: block;
}

/* 앞면 장식 */
.main-card-light {
    position: absolute;
    top: -8%;
    right: -8%;
    width: 55%;
    height: 55%;
    border-radius: 50%;
    background: rgba(255, 255, 255, .12);
    filter: blur(2px);
}

/* ===== 앞면 레이아웃: 상단 고정 + 가운데 가변 + 하단 고정 ===== */
.main-card-front {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.front-top-fixed {
    padding: 1.75em 1.25em 0.5em; /* 28px 20px 8px를 em으로 변환 */
}

.main-card-title {
    margin: 0 0 0.5em; /* 8px를 em으로 변환 */
    font-size: 1.125em; /* 18px를 em으로 변환 */
    font-weight: 900;
    letter-spacing: -0.3px;
}

.main-card-greet {
    margin: 0;
    font-size: clamp(1.125em, 5.6vw, 1.75em); /* 18px-28px를 em으로 변환 */
    font-weight: 800;
    line-height: 1.2;
}

/* 가운데 영역(세로 가운데 정렬) */
.front-center {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.5em; /* 8px를 em으로 변환 */
    padding: 0 1.25em; /* 20px를 em으로 변환 */
    font-size: clamp(0.875em, 4.4vw, 1.125em); /* 14px-18px를 em으로 변환 */
    line-height: 1.55;
}

.front-line {
    margin: 0;
}

.front-multiline {
    white-space: pre-wrap;
}

.front-row {
    display: flex;
    /* gap: 10px; */
    align-items: flex-start;
    font-size: 17px;
}

.front-row .k {
    width: 80px;
    min-width: 80px;
    color: #f3f4f6;
    opacity: .9;
}

.front-row .v {
    flex: 1 1;
    white-space: pre-wrap;
    word-break: break-word;
}

/* 하단 CTA */
.main-card-footer {
    padding: 1.5em 1.25em; /* 24px 20px를 em으로 변환 */
    background: rgba(0, 0, 0, .15);
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.main-cta {
    display: flex;
    align-items: center;
    gap: 0.3125em; /* 5px를 em으로 변환 */
    font-weight: 900;
    font-size: 1.0625em; /* 17px를 em으로 변환 */
    color: #fff;
    background: transparent;
    border: none;
    cursor: pointer;
}

.main-cta-arrow {
    font-size: 14px;
}

.main-cta:hover {
    background: rgba(255, 255, 255, .24);
}

/* 뒷면 */
.main-card-back {
    background: #fff;
    color: #111;
    transform: rotateY(180deg);
    display: block;
}

.main-back-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.main-back-title {
    padding: 1.875em 1.375em; /* 30px 22px를 em으로 변환 */
    font-size: clamp(1.125em, 4.8vw, 1.25em); /* 18px-20px를 em으로 변환 */
    font-weight: 600;
    background: #ffeceb;
}

.main-back-title.cert {
    background: #ebefff;
}

.main-back-list {
    display: grid;
    row-gap: 0.625em; /* 10px를 em으로 변환 */
    column-gap: 0.75em; /* 12px를 em으로 변환 */
    margin: 0;
    padding: 0.75em 1.125em; /* 12px 18px를 em으로 변환 */
    list-style: none;
}

.main-back-list li {
    display: grid;
    grid-template-columns: minmax(4.375em, 5.625em) 1fr; /* 70px-90px를 em으로 변환 */
    font-size: 1em; /* 16px를 em으로 변환 */
    gap: 0.4375em; /* 7px를 em으로 변환 */
}

.main-back-list .k {
    color: #6b7280;
}

.main-back-list .v {
    color: #111;
    white-space: pre-wrap;
    word-break: break-word;
}

.main-back-actions {
    margin-top: auto;
    display: flex;
    justify-content: space-between;
    gap: 0.625em; /* 10px를 em으로 변환 */
    padding: 0.75em 1.125em 1.25em; /* 12px 18px 20px를 em으로 변환 */
}

.main-back-btn {
    min-width: 6em; /* 96px를 em으로 변환 */
    height: 2.5em; /* 40px를 em으로 변환 */
    padding: 0 1em; /* 16px를 em으로 변환 */
    border: none;
    border-radius: 999px;
    background: #ff6a63;
    color: #fff;
    font-weight: 800;
    cursor: pointer;
    box-shadow: 0 0.375em 0.875em rgba(255, 106, 99, .28); /* 6px 14px를 em으로 변환 */
}

.main-back-btn.outline {
    background: #fff;
    color: #111;
    border: 1px solid #e5e7eb;
    box-shadow: 0 1px 2px rgba(0, 0, 0, .15);
    font-weight: 700;
}

/* 플립 중 앞면 CTA 숨김(선택) */
.main-card.is-flipped .main-card-front .main-card-footer {
    display: none;
}

/* 모달 */
.main-modal {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .35);
    display: grid;
    place-items: center;
    z-index: 1000;
}

.main-modal-dialog {
    width: min(86%, 420px);
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 20px 48px rgba(0, 0, 0, .18);
    overflow: hidden;
    animation: mainModalPop .16s ease-out;
}

@keyframes mainModalPop {
    from {
        transform: translateY(8px) scale(.98);
        opacity: 0;
    }

    to {
        transform: translateY(0) scale(1);
        opacity: 1;
    }
}

.main-modal-body {
    padding: 22px 20px 6px;
    text-align: center;
}

.main-modal-title {
    margin: 0 0 8px;
    font-size: 18px;
    font-weight: 800;
    color: #111;
}

.main-modal-desc {
    margin: 0 0 8px;
    font-size: 14px;
    color: #6b7280;
}

.main-modal-actions {
    display: flex;
    justify-content: center;
    gap: 10px;
    padding: 14px 16px 18px;
}

.main-modal-btn {
    min-width: 96px;
    height: 40px;
    padding: 0 16px;
    border: none;
    border-radius: 999px;
    background: #ff6a63;
    color: #fff;
    font-weight: 700;
    cursor: pointer;
    box-shadow: 0 6px 14px rgba(255, 106, 99, .28);
}

.main-modal-btn:active {
    transform: translateY(1px);
}

/* 앞면 중앙 영역 행 레이아웃 공통 */
.front-center {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
    padding: 0 20px;
    font-size: clamp(14px, 4.4vw, 18px);
    line-height: 1.55;
}

/* ===== 모바일 신분증 카드 ===== */
.main-id-card {
    cursor: pointer;
    /* 28px를 em으로 변환 */
    /* border-radius: 1.75em;  */
}

.main-id-card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
    padding: 1.4em 1.5em;
    position: relative;
    overflow: hidden;
    min-height: 0;
    gap: 0.6em;
}

/* 배경 장식 (파도 패턴) */
.main-id-card-content::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 45%;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0.15) 50%, transparent 100%);
    border-radius: 1.75em 1.75em 0 0; /* 28px를 em으로 변환 */
    z-index: 0;
}

/* 프로필 사진 컨테이너 - 카드 폰트(em)에 비례해 스케일 */
.main-id-photo-container {
    width: 100%;
    max-width: 10em;
    aspect-ratio: 1 / 1;
    border-radius: 0.625em;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin: 0.6em 0 0.9em;
    box-shadow: 0 0.125em 0.5em rgba(0, 0, 0, 0.12);
    z-index: 1;
    position: relative;
    flex-shrink: 0;
    padding: 0.5em;
    min-width: 0;
}

.main-id-photo {
    /* width: 100%; */
    max-width: none;
    height: 100%;
    object-fit: contain;
}

.main-id-photo-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f0f0f0;
    color: #999;
}

/* 플레이스홀더 아이콘 - 카드 em에 비례 */
.main-id-photo-placeholder .main-id-photo-icon {
    font-size: 4.5em;
    opacity: 0.5;
}

/* 카드 본문(상단~전화번호) / 하단 로고 영역 분리 */
.main-id-card-body {
    flex: 0 1 auto;
    min-height: 0;
}

.main-id-card-logo-wrap {
    margin-top: auto;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    padding-top: 0.9em;
}

.main-id-card-logo {
    width: 50%;
    max-width: 15em;
    height: auto;
    display: block;
}

/* 이름 */

.main-id-title {
    font-size: 1.3em;
    font-weight: 700;
    color: #000;
    margin: 0 0 0.15em;
}

.main-id-sbtitle {
    font-size: 0.9em;
    color: #9d9d9d;
    font-weight: 500;
    margin: 0 0 0.5em;
}

.main-id-name {
    font-size: 1.6em;
    font-weight: 700;
    color: #000;
    margin: 0.3em 0 0.2em;
    display: inline-block;
}

.main-id-name-char {
    display: inline-block;
}

.main-id-birthday {
    font-size: 1.05em;
    font-weight: 400;
    color: #666;
    margin: 0.15em 0;
    z-index: 1;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0;
    width: 100%;
}

.main-id-birthday .label {
    display: inline-block;
    width: 2em;
    text-align: right;
    color: #666;
}

.main-id-birthday .separator {
    margin: 0 var(--separator-margin, 8px);
    color: #999;
    padding-bottom: 4px;
}

/* 스켈레톤 UI - 실제 요소와 동일한 크기와 위치 */
.main-id-photo-skeleton {
    /* .main-id-photo와 동일한 스타일 */
    max-width: none;
    height: 100%;
    width: 100%;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s ease-in-out infinite;
    border-radius: 0.625em; /* 10px를 em으로 변환 */
    object-fit: contain;
}

.main-id-name-skeleton {
    /* .main-id-name과 동일한 스타일 */
    font-size: 1.875em; /* 30px를 em으로 변환 */
    font-weight: 700;
    margin-bottom: 0.3125em; /* 5px를 em으로 변환 */
    margin-top: 0;
    display: inline-block;
    /* 실제 이름의 평균적인 너비를 시뮬레이션 (한글 3-4자 정도) */
    width: 4.5em; /* 약 3-4자 이름 크기 */
    height: 1.5em; /* line-height 고려 */
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s ease-in-out infinite;
    border-radius: 0.25em; /* 4px를 em으로 변환 */
    vertical-align: baseline;
}

.main-id-info-skeleton {
    /* .main-id-birthday와 동일한 스타일 */
    font-size: 1.0625em; /* 17px를 em으로 변환 */
    font-weight: 400;
    margin-bottom: 0.5em; /* 8px를 em으로 변환 */
    margin-top: 0;
    z-index: 1;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0;
    width: 50%;
    /* 실제 교회명과 직책의 평균적인 너비를 시뮬레이션 */
    height: 1.5em; /* line-height 고려 */
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s ease-in-out infinite;
    border-radius: 0.25em; /* 4px를 em으로 변환 */
}

.main-id-info-skeleton::before {
    /* 교회명과 직책을 시뮬레이션하기 위한 가상 요소 */
    content: '';
    display: inline-block;
    width: 8em; /* 교회명 + 직책 길이 시뮬레이션 */
    height: 100%;
    background: inherit;
    border-radius: inherit;
}

@keyframes skeleton-loading {
    0% {
        background-position: 200% 0;
    }
    100% {
        background-position: -200% 0;
    }
}

.main-id-birthday .value {
    color: #333;
    /* flex: 1; */
    text-align: left;
}

/* QR 코드 컨테이너 */
.main-id-qr-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    background: #fff;
    border-radius: 8px;
    margin-bottom: 5px;
    margin-top: auto;
    z-index: 1;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
}

/* QR 코드(svg)도 화면 크기에 비례해서 축소/확대 */
.main-id-qr-container svg {
    width: min(180px, 40vw);
    height: auto;
}

/* QR 코드 안내 텍스트 */
.main-id-qr-text {
    font-size: 14px;
    color: #111;
    text-align: center;
    z-index: 1;
    font-weight: 500;
    flex-shrink: 0;

    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
}

/* 타이머 컨테이너 (향후 확장용) */
.main-id-timer-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    z-index: 1;
    padding: 0 4px;
}

.main-id-timer-label {
    font-size: 14px;
    color: #111;
    font-weight: 600;
    white-space: nowrap;
}

/* QR 페이지 타이머 점 */
.qr-timer-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #9ca3af;
}

.main-id-timer-value {
    font-size: 16px;
    color: #111;
    font-weight: 700;
    white-space: nowrap;
}

/* 프로그레스 바 */
.main-id-progress-bar {
    flex: 1 1;
    height: 8px;
    background: rgba(255, 255, 255, 0.6);
    border-radius: 4px;
    overflow: hidden;
    position: relative;
}

.main-id-progress-fill {
    height: 100%;
    background: #4A90E2;
    border-radius: 4px;
    transition: width 0.3s ease;
}

.shake-on-open {
    animation: shakeOpen 1.2s ease-out 1;
}

@keyframes shakeOpen {
    0%   { transform: rotateY(0deg); }
    20%  { transform: rotateY(12deg); }
    40%  { transform: rotateY(-10deg); }
    60%  { transform: rotateY(6deg); }
    80%  { transform: rotateY(-3deg); }
    100% { transform: rotateY(0deg); }
}

`, "",{"version":3,"sources":["webpack://./src/Pages/css/main.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gGAAgG;IAChG,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,oDAAoD;IACpD,uBAAuB;IACvB,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA,sDAAsD;AACtD;IACI,4BAA4B;IAC5B,WAAW;IACX,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,oDAAoD;IACpD,yDAAyD;IACzD,oEAAoE;IACpE,uBAAuB;IACvB,YAAY;IACZ,4CAA4C;IAC5C,cAAc;IACd,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;AAChB;;AAEA,uBAAuB;AACvB;IACI,WAAW;IACX,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,iDAAiD;IACjD,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,8CAA8C;AAClD;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,SAAS;IACT,qBAAqB;IACrB,gCAAgC;IAChC,uBAAuB;IACvB,oDAAoD;IACpD,yDAAyD;IACzD,oEAAoE;IACpE,4CAA4C;IAC5C,gBAAgB;IAChB,mCAAmC;IACnC,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,+CAA+C;IAC/C,qCAAqC;IACrC,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,oCAAoC;IACpC,uDAAuD;AAC3D;;AAEA,aAAa;AACb;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA,oBAAoB;AACpB;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,sBAAsB;IACtB,2BAA2B;IAC3B,mCAAmC;IACnC,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA,UAAU;AACV;IACI,kBAAkB;IAClB,cAAc,EAAE,kBAAkB;IAClC,cAAc,EAAE,iBAAiB;IACjC,eAAe;IACf,eAAe;IACf,iCAAiC;IACjC,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,YAAY,EAAE,iBAAiB;IAC/B,gBAAgB;IAChB,kBAAkB,EAAE,kBAAkB;IACtC,WAAW;AACf;;AAEA;IACI,cAAc,EAAE,kBAAkB;IAClC,eAAe,EAAE,kBAAkB;IACnC,cAAc;AAClB;;AAEA,UAAU;AACV;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,oCAAoC;IACpC,iBAAiB;AACrB;;AAEA,gDAAgD;AAChD;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,4BAA4B,EAAE,2BAA2B;AAC7D;;AAEA;IACI,iBAAiB,EAAE,iBAAiB;IACpC,kBAAkB,EAAE,kBAAkB;IACtC,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,wCAAwC,EAAE,uBAAuB;IACjE,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,UAAU,EAAE,iBAAiB;IAC7B,iBAAiB,EAAE,kBAAkB;IACrC,yCAAyC,EAAE,uBAAuB;IAClE,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,cAAc;IACd,WAAW;AACf;;AAEA;IACI,SAAO;IACP,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA,WAAW;AACX;IACI,qBAAqB,EAAE,uBAAuB;IAC9C,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa,EAAE,iBAAiB;IAChC,gBAAgB;IAChB,mBAAmB,EAAE,kBAAkB;IACvC,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA,OAAO;AACP;IACI,gBAAgB;IAChB,WAAW;IACX,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,wBAAwB,EAAE,uBAAuB;IACjD,wCAAwC,EAAE,uBAAuB;IACjE,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB,EAAE,kBAAkB;IACpC,kBAAkB,EAAE,kBAAkB;IACtC,SAAS;IACT,uBAAuB,EAAE,uBAAuB;IAChD,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mDAAmD,EAAE,uBAAuB;IAC5E,cAAc,EAAE,kBAAkB;IAClC,aAAa,EAAE,iBAAiB;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,YAAY,EAAE,kBAAkB;IAChC,8BAA8B,EAAE,4BAA4B;AAChE;;AAEA;IACI,cAAc,EAAE,kBAAkB;IAClC,aAAa,EAAE,kBAAkB;IACjC,cAAc,EAAE,kBAAkB;IAClC,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,qDAAqD,EAAE,sBAAsB;AACjF;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,wCAAwC;IACxC,gBAAgB;AACpB;;AAEA,uBAAuB;AACvB;IACI,aAAa;AACjB;;AAEA,OAAO;AACP;IACI,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI;QACI,qCAAqC;QACrC,UAAU;IACd;;IAEA;QACI,iCAAiC;QACjC,UAAU;IACd;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,uBAAuB;AACvB;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,mCAAmC;IACnC,iBAAiB;AACrB;;AAEA,2BAA2B;AAC3B;IACI,eAAe;IACf,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,UAAU;AACd;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,kHAAkH;IAClH,gCAAgC,EAAE,kBAAkB;IACpD,UAAU;AACd;;AAEA,qCAAqC;AACrC;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;IACrB,+CAA+C;IAC/C,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA,2BAA2B;AAC3B;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA,iCAAiC;AACjC;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,YAAY;IACZ,cAAc;AAClB;;AAEA,OAAO;;AAEP;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,sCAAsC;IACtC,WAAW;IACX,mBAAmB;AACvB;;AAEA,gCAAgC;AAChC;IACI,4BAA4B;IAC5B,eAAe;IACf,YAAY;IACZ,WAAW;IACX,yEAAyE;IACzE,0BAA0B;IAC1B,qDAAqD;IACrD,sBAAsB,EAAE,kBAAkB;IAC1C,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB,EAAE,kBAAkB;IACtC,gBAAgB;IAChB,uBAAuB,EAAE,iBAAiB;IAC1C,aAAa;IACb,qBAAqB;IACrB,uCAAuC;IACvC,YAAY,EAAE,iBAAiB;IAC/B,aAAa,EAAE,mBAAmB;IAClC,yEAAyE;IACzE,0BAA0B;IAC1B,qDAAqD;IACrD,qBAAqB,EAAE,iBAAiB;IACxC,wBAAwB;AAC5B;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB,EAAE,kBAAkB;IACvC,gBAAgB;IAChB,oBAAoB,EAAE,iBAAiB;IACvC,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,MAAM;IACN,UAAU;IACV,+BAA+B;IAC/B,aAAa,EAAE,mBAAmB;IAClC,yEAAyE;IACzE,0BAA0B;IAC1B,qDAAqD;IACrD,qBAAqB,EAAE,iBAAiB;AAC5C;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,qBAAqB;IACrB,UAAU,EAAE,sBAAsB;IAClC,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,wCAAwC;IACxC,cAAc;AAClB;;AAEA,kCAAkC;AAClC;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,cAAc;;IAEd,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;AAC/B;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,YAAY;AACZ;IACI,SAAO;IACP,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,OAAO,wBAAwB,EAAE;IACjC,OAAO,yBAAyB,EAAE;IAClC,OAAO,0BAA0B,EAAE;IACnC,OAAO,wBAAwB,EAAE;IACjC,OAAO,yBAAyB,EAAE;IAClC,OAAO,wBAAwB,EAAE;AACrC","sourcesContent":["/* ===== 공용 ===== */\r\n.container-wrap {\r\n    width: 100%;\r\n    position: relative;\r\n    min-height: 100%;\r\n}\r\n\r\n.main-wrap {\r\n    position: relative;\r\n    /* min-height: 100vh; */\r\n    width: 100%;\r\n}\r\n\r\n.main-background-image {\r\n    /* position: fixed; */\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    z-index: 0;\r\n    pointer-events: none;\r\n}\r\n\r\n.main-viewport {\r\n    width: 100%;\r\n    max-width: 600px;\r\n    min-height: 100dvh;\r\n    margin: 0 auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    position: relative;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\r\n    z-index: 1;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.main-content {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    /* 비율대로 조정되도록 em 단위 사용 (기본 16px 기준으로 40px = 2.5em) */\r\n    /* margin-top: 1.5em; */\r\n    /* 최소 높이 설정하여 내용이 없어도 화면이 보이도록 */\r\n    min-height: calc(100vh - 240px);\r\n}\r\n\r\n/* QR 페이지: 카드 비율 고정(312:512), PC에서 화면 밖으로 나가지 않도록 제한 */\r\n.qr-page-content {\r\n    transform: translateY(-15px);\r\n    width: 100%;\r\n    max-width: 100%;\r\n    min-height: 0;\r\n    overflow: hidden;\r\n    box-sizing: border-box;\r\n}\r\n.qr-page-content .main-slide {\r\n    width: 100%;\r\n    max-width: 85%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    box-sizing: border-box;\r\n}\r\n.qr-page-content .main-card {\r\n    /* PC에서도 화면 안: 100%·80vw·높이기준 중 최소값, 뷰포트 절대 초과 안 함 */\r\n    width: min(100%, 80vw, calc((100vh - 240px) * 312 / 512));\r\n    max-width: min(100%, 80vw, calc((100vh - 240px) * 312 / 512), 100vw);\r\n    aspect-ratio: 312 / 512;\r\n    height: auto;\r\n    max-height: min(calc(100vh - 240px), 100dvh);\r\n    flex-shrink: 0;\r\n    box-sizing: border-box;\r\n}\r\n.qr-page-content .main-card-inner {\r\n    position: absolute;\r\n    inset: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n/* ===== Swiper ===== */\r\n.main-swiper-area {\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n    overflow: visible;\r\n}\r\n\r\n.main-slide {\r\n    /* Swiper 슬라이드 컨테이너 - 실제 카드 크기는 .main-card에서 제어 */\r\n    display: flex !important;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: auto;\r\n    /* 카드 크기는 .main-card에서 직접 제어하므로 여기서는 제한하지 않음 */\r\n}\r\n\r\n.swiper,\r\n.main-swiper {\r\n    overflow: visible !important;\r\n}\r\n\r\n.main-swiper .swiper-pagination {\r\n    position: static;\r\n    margin: 20px auto 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    transform: translateX(0) !important;\r\n}\r\n\r\n.main-swiper .swiper-pagination-bullet {\r\n    width: 11px;\r\n    height: 11px;\r\n    background: #c8cdd6;\r\n    opacity: 1;\r\n    margin: 0 4px !important;\r\n}\r\n\r\n.main-swiper .swiper-pagination-bullet-active {\r\n    background: #101217;\r\n}\r\n\r\n/* ===== 카드 공통 ===== */\r\n.main-card {\r\n    position: relative;\r\n    margin: 0;\r\n    border-radius: 1.75em;\r\n    border-top-right-radius: 4.375em;\r\n    aspect-ratio: 312 / 512;\r\n    /* PC에서 화면 밖으로 나가지 않도록: 100%, 80vw, 높이기준, 100vw 상한 */\r\n    width: min(100%, 80vw, calc((100vh - 240px) * 312 / 512));\r\n    max-width: min(100%, 80vw, calc((100vh - 240px) * 312 / 512), 100vw);\r\n    max-height: min(calc(100vh - 240px), 100dvh);\r\n    min-width: 200px;\r\n    min-height: calc(200px * 512 / 312);\r\n    height: auto;\r\n    flex-shrink: 0;\r\n    box-sizing: border-box;\r\n    /* 뷰포트(vmin) 비율: 화면이 커질수록 폰트·컨텐츠가 같은 퍼센트로 커지게 */\r\n    font-size: clamp(12px, 4.8vmin, 28px);\r\n    color: #fff;\r\n    perspective: 1200px;\r\n    overflow: visible;\r\n    will-change: transform;\r\n}\r\n\r\n.main-card-inner {\r\n    position: absolute;\r\n    inset: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    border-radius: inherit;\r\n    transform-style: preserve-3d;\r\n    -webkit-transform-style: preserve-3d;\r\n    transition: transform 800ms cubic-bezier(.2, .8, .2, 1);\r\n}\r\n\r\n/* + 카드 스타일 */\r\n.main-add-card {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.main-add-card .main-card-inner {\r\n    position: relative;\r\n    transform: none !important;\r\n}\r\n\r\n/* 관리자 승인 대기 카드 스타일 */\r\n.main-card-pending {\r\n    position: relative;\r\n}\r\n\r\n.main-card-pending-overlay {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    border-radius: inherit;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 10;\r\n}\r\n\r\n.main-card-pending-message {\r\n    background: rgba(255, 255, 255, 0.95);\r\n    color: #666;\r\n    padding: 1em 1.5em;\r\n    border-radius: 0.75em;\r\n    font-size: 1em;\r\n    font-weight: 600;\r\n    text-align: center;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.main-card-pending .main-card-face {\r\n    filter: grayscale(100%);\r\n    opacity: 0.6;\r\n}\r\n\r\n/* 승인된 자격증은 정상 스타일 */\r\n.main-card:not(.main-card-pending) .main-card-face {\r\n    filter: none;\r\n    opacity: 1;\r\n}\r\n\r\n.main-card.is-flipped .main-card-inner {\r\n    transform: rotateY(180deg);\r\n}\r\n\r\n.main-card-face {\r\n    position: absolute;\r\n    inset: 0;\r\n    border-radius: inherit;\r\n    backface-visibility: hidden;\r\n    -webkit-backface-visibility: hidden;\r\n    overflow: hidden;\r\n    transform: translateZ(0.01px);\r\n}\r\n\r\n/* 상단 배지 */\r\n.main-type-badge {\r\n    position: absolute;\r\n    top: -2.1875em; /* 35px를 em으로 변환 */\r\n    left: 0.3125em; /* 5px를 em으로 변환 */\r\n    /* top: 15px; */\r\n    /* left: 50%; */\r\n    /* transform: translateX(-50%); */\r\n    z-index: 3;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 0.125em; /* 2px를 em으로 변환 */\r\n    font-weight: 800;\r\n    font-size: 1.125em; /* 18px를 em으로 변환 */\r\n    color: #000;\r\n}\r\n\r\n.main-type-badge img {\r\n    width: 1.625em; /* 26px를 em으로 변환 */\r\n    height: 1.625em; /* 26px를 em으로 변환 */\r\n    display: block;\r\n}\r\n\r\n/* 앞면 장식 */\r\n.main-card-light {\r\n    position: absolute;\r\n    top: -8%;\r\n    right: -8%;\r\n    width: 55%;\r\n    height: 55%;\r\n    border-radius: 50%;\r\n    background: rgba(255, 255, 255, .12);\r\n    filter: blur(2px);\r\n}\r\n\r\n/* ===== 앞면 레이아웃: 상단 고정 + 가운데 가변 + 하단 고정 ===== */\r\n.main-card-front {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n}\r\n\r\n.front-top-fixed {\r\n    padding: 1.75em 1.25em 0.5em; /* 28px 20px 8px를 em으로 변환 */\r\n}\r\n\r\n.main-card-title {\r\n    margin: 0 0 0.5em; /* 8px를 em으로 변환 */\r\n    font-size: 1.125em; /* 18px를 em으로 변환 */\r\n    font-weight: 900;\r\n    letter-spacing: -0.3px;\r\n}\r\n\r\n.main-card-greet {\r\n    margin: 0;\r\n    font-size: clamp(1.125em, 5.6vw, 1.75em); /* 18px-28px를 em으로 변환 */\r\n    font-weight: 800;\r\n    line-height: 1.2;\r\n}\r\n\r\n/* 가운데 영역(세로 가운데 정렬) */\r\n.front-center {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    gap: 0.5em; /* 8px를 em으로 변환 */\r\n    padding: 0 1.25em; /* 20px를 em으로 변환 */\r\n    font-size: clamp(0.875em, 4.4vw, 1.125em); /* 14px-18px를 em으로 변환 */\r\n    line-height: 1.55;\r\n}\r\n\r\n.front-line {\r\n    margin: 0;\r\n}\r\n\r\n.front-multiline {\r\n    white-space: pre-wrap;\r\n}\r\n\r\n.front-row {\r\n    display: flex;\r\n    /* gap: 10px; */\r\n    align-items: flex-start;\r\n    font-size: 17px;\r\n}\r\n\r\n.front-row .k {\r\n    width: 80px;\r\n    min-width: 80px;\r\n    color: #f3f4f6;\r\n    opacity: .9;\r\n}\r\n\r\n.front-row .v {\r\n    flex: 1;\r\n    white-space: pre-wrap;\r\n    word-break: break-word;\r\n}\r\n\r\n/* 하단 CTA */\r\n.main-card-footer {\r\n    padding: 1.5em 1.25em; /* 24px 20px를 em으로 변환 */\r\n    background: rgba(0, 0, 0, .15);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.main-cta {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.3125em; /* 5px를 em으로 변환 */\r\n    font-weight: 900;\r\n    font-size: 1.0625em; /* 17px를 em으로 변환 */\r\n    color: #fff;\r\n    background: transparent;\r\n    border: none;\r\n    cursor: pointer;\r\n}\r\n\r\n.main-cta-arrow {\r\n    font-size: 14px;\r\n}\r\n\r\n.main-cta:hover {\r\n    background: rgba(255, 255, 255, .24);\r\n}\r\n\r\n/* 뒷면 */\r\n.main-card-back {\r\n    background: #fff;\r\n    color: #111;\r\n    transform: rotateY(180deg);\r\n    display: block;\r\n}\r\n\r\n.main-back-content {\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n}\r\n\r\n.main-back-title {\r\n    padding: 1.875em 1.375em; /* 30px 22px를 em으로 변환 */\r\n    font-size: clamp(1.125em, 4.8vw, 1.25em); /* 18px-20px를 em으로 변환 */\r\n    font-weight: 600;\r\n    background: #ffeceb;\r\n}\r\n\r\n.main-back-title.cert {\r\n    background: #ebefff;\r\n}\r\n\r\n.main-back-list {\r\n    display: grid;\r\n    row-gap: 0.625em; /* 10px를 em으로 변환 */\r\n    column-gap: 0.75em; /* 12px를 em으로 변환 */\r\n    margin: 0;\r\n    padding: 0.75em 1.125em; /* 12px 18px를 em으로 변환 */\r\n    list-style: none;\r\n}\r\n\r\n.main-back-list li {\r\n    display: grid;\r\n    grid-template-columns: minmax(4.375em, 5.625em) 1fr; /* 70px-90px를 em으로 변환 */\r\n    font-size: 1em; /* 16px를 em으로 변환 */\r\n    gap: 0.4375em; /* 7px를 em으로 변환 */\r\n}\r\n\r\n.main-back-list .k {\r\n    color: #6b7280;\r\n}\r\n\r\n.main-back-list .v {\r\n    color: #111;\r\n    white-space: pre-wrap;\r\n    word-break: break-word;\r\n}\r\n\r\n.main-back-actions {\r\n    margin-top: auto;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    gap: 0.625em; /* 10px를 em으로 변환 */\r\n    padding: 0.75em 1.125em 1.25em; /* 12px 18px 20px를 em으로 변환 */\r\n}\r\n\r\n.main-back-btn {\r\n    min-width: 6em; /* 96px를 em으로 변환 */\r\n    height: 2.5em; /* 40px를 em으로 변환 */\r\n    padding: 0 1em; /* 16px를 em으로 변환 */\r\n    border: none;\r\n    border-radius: 999px;\r\n    background: #ff6a63;\r\n    color: #fff;\r\n    font-weight: 800;\r\n    cursor: pointer;\r\n    box-shadow: 0 0.375em 0.875em rgba(255, 106, 99, .28); /* 6px 14px를 em으로 변환 */\r\n}\r\n\r\n.main-back-btn.outline {\r\n    background: #fff;\r\n    color: #111;\r\n    border: 1px solid #e5e7eb;\r\n    box-shadow: 0 1px 2px rgba(0, 0, 0, .15);\r\n    font-weight: 700;\r\n}\r\n\r\n/* 플립 중 앞면 CTA 숨김(선택) */\r\n.main-card.is-flipped .main-card-front .main-card-footer {\r\n    display: none;\r\n}\r\n\r\n/* 모달 */\r\n.main-modal {\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(0, 0, 0, .35);\r\n    display: grid;\r\n    place-items: center;\r\n    z-index: 1000;\r\n}\r\n\r\n.main-modal-dialog {\r\n    width: min(86%, 420px);\r\n    background: #fff;\r\n    border-radius: 14px;\r\n    box-shadow: 0 20px 48px rgba(0, 0, 0, .18);\r\n    overflow: hidden;\r\n    animation: mainModalPop .16s ease-out;\r\n}\r\n\r\n@keyframes mainModalPop {\r\n    from {\r\n        transform: translateY(8px) scale(.98);\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        transform: translateY(0) scale(1);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.main-modal-body {\r\n    padding: 22px 20px 6px;\r\n    text-align: center;\r\n}\r\n\r\n.main-modal-title {\r\n    margin: 0 0 8px;\r\n    font-size: 18px;\r\n    font-weight: 800;\r\n    color: #111;\r\n}\r\n\r\n.main-modal-desc {\r\n    margin: 0 0 8px;\r\n    font-size: 14px;\r\n    color: #6b7280;\r\n}\r\n\r\n.main-modal-actions {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 10px;\r\n    padding: 14px 16px 18px;\r\n}\r\n\r\n.main-modal-btn {\r\n    min-width: 96px;\r\n    height: 40px;\r\n    padding: 0 16px;\r\n    border: none;\r\n    border-radius: 999px;\r\n    background: #ff6a63;\r\n    color: #fff;\r\n    font-weight: 700;\r\n    cursor: pointer;\r\n    box-shadow: 0 6px 14px rgba(255, 106, 99, .28);\r\n}\r\n\r\n.main-modal-btn:active {\r\n    transform: translateY(1px);\r\n}\r\n\r\n/* 앞면 중앙 영역 행 레이아웃 공통 */\r\n.front-center {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    gap: 10px;\r\n    padding: 0 20px;\r\n    font-size: clamp(14px, 4.4vw, 18px);\r\n    line-height: 1.55;\r\n}\r\n\r\n/* ===== 모바일 신분증 카드 ===== */\r\n.main-id-card {\r\n    cursor: pointer;\r\n    /* 28px를 em으로 변환 */\r\n    /* border-radius: 1.75em;  */\r\n}\r\n\r\n.main-id-card-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    height: 100%;\r\n    padding: 1.4em 1.5em;\r\n    position: relative;\r\n    overflow: hidden;\r\n    min-height: 0;\r\n    gap: 0.6em;\r\n}\r\n\r\n/* 배경 장식 (파도 패턴) */\r\n.main-id-card-content::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    height: 45%;\r\n    background: linear-gradient(180deg, rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0.15) 50%, transparent 100%);\r\n    border-radius: 1.75em 1.75em 0 0; /* 28px를 em으로 변환 */\r\n    z-index: 0;\r\n}\r\n\r\n/* 프로필 사진 컨테이너 - 카드 폰트(em)에 비례해 스케일 */\r\n.main-id-photo-container {\r\n    width: 100%;\r\n    max-width: 10em;\r\n    aspect-ratio: 1 / 1;\r\n    border-radius: 0.625em;\r\n    background: #fff;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    overflow: hidden;\r\n    margin: 0.6em 0 0.9em;\r\n    box-shadow: 0 0.125em 0.5em rgba(0, 0, 0, 0.12);\r\n    z-index: 1;\r\n    position: relative;\r\n    flex-shrink: 0;\r\n    padding: 0.5em;\r\n    min-width: 0;\r\n}\r\n\r\n.main-id-photo {\r\n    /* width: 100%; */\r\n    max-width: none;\r\n    height: 100%;\r\n    object-fit: contain;\r\n}\r\n\r\n.main-id-photo-placeholder {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: #f0f0f0;\r\n    color: #999;\r\n}\r\n\r\n/* 플레이스홀더 아이콘 - 카드 em에 비례 */\r\n.main-id-photo-placeholder .main-id-photo-icon {\r\n    font-size: 4.5em;\r\n    opacity: 0.5;\r\n}\r\n\r\n/* 카드 본문(상단~전화번호) / 하단 로고 영역 분리 */\r\n.main-id-card-body {\r\n    flex: 0 1 auto;\r\n    min-height: 0;\r\n}\r\n\r\n.main-id-card-logo-wrap {\r\n    margin-top: auto;\r\n    flex-shrink: 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    padding-top: 0.9em;\r\n}\r\n\r\n.main-id-card-logo {\r\n    width: 50%;\r\n    max-width: 15em;\r\n    height: auto;\r\n    display: block;\r\n}\r\n\r\n/* 이름 */\r\n\r\n.main-id-title {\r\n    font-size: 1.3em;\r\n    font-weight: 700;\r\n    color: #000;\r\n    margin: 0 0 0.15em;\r\n}\r\n\r\n.main-id-sbtitle {\r\n    font-size: 0.9em;\r\n    color: #9d9d9d;\r\n    font-weight: 500;\r\n    margin: 0 0 0.5em;\r\n}\r\n\r\n.main-id-name {\r\n    font-size: 1.6em;\r\n    font-weight: 700;\r\n    color: #000;\r\n    margin: 0.3em 0 0.2em;\r\n    display: inline-block;\r\n}\r\n\r\n.main-id-name-char {\r\n    display: inline-block;\r\n}\r\n\r\n.main-id-birthday {\r\n    font-size: 1.05em;\r\n    font-weight: 400;\r\n    color: #666;\r\n    margin: 0.15em 0;\r\n    z-index: 1;\r\n    text-align: center;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 0;\r\n    width: 100%;\r\n}\r\n\r\n.main-id-birthday .label {\r\n    display: inline-block;\r\n    width: 2em;\r\n    text-align: right;\r\n    color: #666;\r\n}\r\n\r\n.main-id-birthday .separator {\r\n    margin: 0 var(--separator-margin, 8px);\r\n    color: #999;\r\n    padding-bottom: 4px;\r\n}\r\n\r\n/* 스켈레톤 UI - 실제 요소와 동일한 크기와 위치 */\r\n.main-id-photo-skeleton {\r\n    /* .main-id-photo와 동일한 스타일 */\r\n    max-width: none;\r\n    height: 100%;\r\n    width: 100%;\r\n    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\r\n    background-size: 200% 100%;\r\n    animation: skeleton-loading 1.5s ease-in-out infinite;\r\n    border-radius: 0.625em; /* 10px를 em으로 변환 */\r\n    object-fit: contain;\r\n}\r\n\r\n.main-id-name-skeleton {\r\n    /* .main-id-name과 동일한 스타일 */\r\n    font-size: 1.875em; /* 30px를 em으로 변환 */\r\n    font-weight: 700;\r\n    margin-bottom: 0.3125em; /* 5px를 em으로 변환 */\r\n    margin-top: 0;\r\n    display: inline-block;\r\n    /* 실제 이름의 평균적인 너비를 시뮬레이션 (한글 3-4자 정도) */\r\n    width: 4.5em; /* 약 3-4자 이름 크기 */\r\n    height: 1.5em; /* line-height 고려 */\r\n    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\r\n    background-size: 200% 100%;\r\n    animation: skeleton-loading 1.5s ease-in-out infinite;\r\n    border-radius: 0.25em; /* 4px를 em으로 변환 */\r\n    vertical-align: baseline;\r\n}\r\n\r\n.main-id-info-skeleton {\r\n    /* .main-id-birthday와 동일한 스타일 */\r\n    font-size: 1.0625em; /* 17px를 em으로 변환 */\r\n    font-weight: 400;\r\n    margin-bottom: 0.5em; /* 8px를 em으로 변환 */\r\n    margin-top: 0;\r\n    z-index: 1;\r\n    text-align: center;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 0;\r\n    width: 50%;\r\n    /* 실제 교회명과 직책의 평균적인 너비를 시뮬레이션 */\r\n    height: 1.5em; /* line-height 고려 */\r\n    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\r\n    background-size: 200% 100%;\r\n    animation: skeleton-loading 1.5s ease-in-out infinite;\r\n    border-radius: 0.25em; /* 4px를 em으로 변환 */\r\n}\r\n\r\n.main-id-info-skeleton::before {\r\n    /* 교회명과 직책을 시뮬레이션하기 위한 가상 요소 */\r\n    content: '';\r\n    display: inline-block;\r\n    width: 8em; /* 교회명 + 직책 길이 시뮬레이션 */\r\n    height: 100%;\r\n    background: inherit;\r\n    border-radius: inherit;\r\n}\r\n\r\n@keyframes skeleton-loading {\r\n    0% {\r\n        background-position: 200% 0;\r\n    }\r\n    100% {\r\n        background-position: -200% 0;\r\n    }\r\n}\r\n\r\n.main-id-birthday .value {\r\n    color: #333;\r\n    /* flex: 1; */\r\n    text-align: left;\r\n}\r\n\r\n/* QR 코드 컨테이너 */\r\n.main-id-qr-container {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 12px;\r\n    background: #fff;\r\n    border-radius: 8px;\r\n    margin-bottom: 5px;\r\n    margin-top: auto;\r\n    z-index: 1;\r\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);\r\n    flex-shrink: 0;\r\n}\r\n\r\n/* QR 코드(svg)도 화면 크기에 비례해서 축소/확대 */\r\n.main-id-qr-container svg {\r\n    width: min(180px, 40vw);\r\n    height: auto;\r\n}\r\n\r\n/* QR 코드 안내 텍스트 */\r\n.main-id-qr-text {\r\n    font-size: 14px;\r\n    color: #111;\r\n    text-align: center;\r\n    z-index: 1;\r\n    font-weight: 500;\r\n    flex-shrink: 0;\r\n\r\n    position: absolute;\r\n    bottom: 20px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n}\r\n\r\n/* 타이머 컨테이너 (향후 확장용) */\r\n.main-id-timer-container {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 12px;\r\n    z-index: 1;\r\n    padding: 0 4px;\r\n}\r\n\r\n.main-id-timer-label {\r\n    font-size: 14px;\r\n    color: #111;\r\n    font-weight: 600;\r\n    white-space: nowrap;\r\n}\r\n\r\n/* QR 페이지 타이머 점 */\r\n.qr-timer-dot {\r\n    width: 10px;\r\n    height: 10px;\r\n    border-radius: 50%;\r\n    background-color: #9ca3af;\r\n}\r\n\r\n.main-id-timer-value {\r\n    font-size: 16px;\r\n    color: #111;\r\n    font-weight: 700;\r\n    white-space: nowrap;\r\n}\r\n\r\n/* 프로그레스 바 */\r\n.main-id-progress-bar {\r\n    flex: 1;\r\n    height: 8px;\r\n    background: rgba(255, 255, 255, 0.6);\r\n    border-radius: 4px;\r\n    overflow: hidden;\r\n    position: relative;\r\n}\r\n\r\n.main-id-progress-fill {\r\n    height: 100%;\r\n    background: #4A90E2;\r\n    border-radius: 4px;\r\n    transition: width 0.3s ease;\r\n}\r\n\r\n.shake-on-open {\r\n    animation: shakeOpen 1.2s ease-out 1;\r\n}\r\n\r\n@keyframes shakeOpen {\r\n    0%   { transform: rotateY(0deg); }\r\n    20%  { transform: rotateY(12deg); }\r\n    40%  { transform: rotateY(-10deg); }\r\n    60%  { transform: rotateY(6deg); }\r\n    80%  { transform: rotateY(-3deg); }\r\n    100% { transform: rotateY(0deg); }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
